<template>
  <svg>
    <use :xlink:href="`/assets/img/sprite-icon-svg.svg#sprite-${name}`"></use>
  </svg>
</template>

<script>
export default {
  name: 'svg-img',
  props: {
    name: {
      required: true,
      type: String,
      default: '',
    },
  },
};
</script>
